var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cssload-loader"},[_c('div',{staticClass:"cssload-inner cssload-one"}),_vm._v(" "),_c('div',{staticClass:"cssload-inner cssload-two"}),_vm._v(" "),_c('div',{staticClass:"cssload-inner cssload-three"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67d4f007","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/DataLoading.vue
// module id = 395
// module chunks = 1